import * as React from "react";
import moment from "moment";

import NewButton from "../../components/uiMerge/newButton";
import AntAvatar from "../shared/AntAvatar";
import { ReactivateCustomerController } from "@njoy/controller";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from "../../hooks/useToast";
import * as ROUTES from "../../constants/routes";

export const PageAccountPendingDeletion: React.FC = (
  props
) => {
  const [email, setEmail] = React.useState<string>("");
  const [name, setName] = React.useState<string>("");
  const [deactivationDate, setDeactivationDate] = React.useState<string | null>(null);
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const deletionDateLabel = React.useMemo(() => {
    const parsedDate = deactivationDate
      ? moment(deactivationDate, moment.ISO_8601, true)
      : moment.invalid();

    const safeBaseDate = parsedDate.isValid() ? parsedDate : moment();
    return safeBaseDate.add(30, "days").format("MMMM DD, YYYY");
  }, [deactivationDate]);

  React.useEffect(() => {
    const foundEmail = localStorage.getItem('email');
    const foundName = localStorage.getItem("name");
    const foundDeactivationDate = localStorage.getItem("deactivationDate");

    setEmail(foundEmail || "");
    setName(foundName || "");
    setDeactivationDate(foundDeactivationDate || null);
  }, [])

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <ReactivateCustomerController>
      {({ submitReactivateCustomer }:{submitReactivateCustomer:any}) => {
        return(
          <>
            <ToastContainer />
            
            <div className="w-full flex flex-col justify-center items-center  py-6 px-[1rem]">
              <div className=" w-full flex flex-col justify-center gap-2 mt-[14rem] items-center">
                <AntAvatar firstname={name.split(" ")[0]} lastname={name.split(" ")[1]} width="110px" height="110px" fontSize="28px"/>

                <div className="">
                  <div>
                    <h2
                      className={
                        "text-[24px] w-full text-center text-white font-bold mt-5 mb-1"
                      }
                    >
                      Account Pending Deletion
                    </h2>
                  </div>
                  <div className="text-[#CECECF] font-[300] opacity-80 text-center text-[16px] mb-6">
                    <p>
                      This account is set to be permanently deleted after 30 days. You
                      can restore it now or let it be deleted on 
                      <span className="ml-2">
                        {deletionDateLabel}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-3 w-full mt-[13rem]">
                  <NewButton
                    fullWidth
                    variant="primary"
                    onClick={async() => {
                      const errors = await submitReactivateCustomer({
                        email
                      })
                      console.log("reactivate res ", errors)
                      if(errors === null) {
                        localStorage.removeItem("email");
                        localStorage.removeItem("name");
                        localStorage.removeItem("deactivationDate");
                        ToastMessage("success", "User account reactivated successfully.");

                        timeoutRef.current = setTimeout(() => {
                          window.location.replace(ROUTES.LOGIN);
                        }, 2000);
                      } else {
                        ToastMessage("error", errors.deactivation || errors.user)
                      }
                    }}
                  >
                    Restore My Account
                  </NewButton>
                  <NewButton
                    fullWidth
                    variant="outline"
                    onClick={() => {
                      localStorage.removeItem("email");
                      localStorage.removeItem("name");
                      localStorage.removeItem("deactivationDate");
                      window.location.replace(ROUTES.LOGIN);
                    }}
                  >
                    Return to Login
                  </NewButton>
                </div>
              </div>
            </div>
          </>
        )
      }}
    </ReactivateCustomerController>
  );
};


